import ReactDOM from "react-dom";
import App from "./components/App";

import "./assets/css/reset.css";
import "./assets/css/style.css";


ReactDOM.render(<App />, document.querySelector(".root"));